<section class="container py-5" *ngIf="policyInfo && quotationInfo">
    <div class="back-button mb-4">
        <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
        <h4 class="back-button-heading mx-3">Policy Info</h4>
    </div>
    <div class="d-flex justify-content-between">
        <div></div>
        <div class="policy-number">Policy Number : {{policyInfo.PolicyNumber}}</div>
        <div class="button-section">
            <i class="fa-solid fa-cloud-arrow-down mb-3 me-md-4" title="Download Policy"
                (click)="DownloadPolicy(policyInfo.certificateID)"></i>
        </div>
    </div>
    <div class="card rounded-0 mb-2">
        <div class="card-body d-md-flex justify-content-between px-4 py-3">
            <div><strong>Quotation Number :</strong> {{quotationInfo?.QuotationNumber}}</div>
            <div><strong>Product Name :</strong> {{selectedProduct?.ProductName}}</div>
            <div><strong>Premium Amount : </strong> <strong
                    class="text-primary">{{selectedProduct?.sTotalAmount}}</strong></div>
        </div>
    </div>
    <div class="card rounded-0">
        <div class="card-body">
            <div class="d-md-flex align-items-stretch">
                <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <div class="stage-item"
                        *ngFor="let underwritingDetail of underwritingInfo.underwritingDetails; let i = index;let isFirst=first;let isLast=last">
                        <button [ngClass]="{'active': isFirst}" class="nav-link" (click)="changeActiveIndex(i)"
                            id="v-pills-{{underwritingDetail.id}}-tab" data-bs-toggle="pill"
                            [attr.data-bs-target]="'#v-pills-' + underwritingDetail.id" type="button" role="tab"
                            [attr.aria-controls]="'v-pills-' + underwritingDetail.id" aria-selected="true">
                            <i class="fa-solid fa-circle-check"></i> {{underwritingDetail.title}}
                        </button>
                        <div *ngIf="!isLast" class="py-3 stage-status"
                            [ngClass]="{'border-assign-default': currentActiveIndex<=i, 'border-assign-success': currentActiveIndex>i}">
                        </div>
                    </div>

                </div>

                <div class="tab-content w-100 p-2 p-md-4 py-md-0" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="v-pills-1" role="tabpanel"
                        aria-labelledby="v-pills-1-tab" tabindex="0">
                        <div class="heading2 mb-4">Quote Information</div>
                        <section>
                            <form [formGroup]="quotationFieldsForm">
                                <div class="mb-4">
                                    <label class="field-label d-block mb-3">Travel Purpose </label>
                                    <div class="btn-group" role="group" aria-label="Travel Purpose">
                                        <ng-container *ngFor="let travelPurpose of getTravelPurposeList">
                                            <input type="radio" class="btn-check" [id]="travelPurpose.masterDataID"
                                                [value]="travelPurpose.masterDataID" formControlName="travelPurpose">
                                            <label class="btn rounded radio-outline-button me-2 px-2 px-md-5 py-2"
                                                [for]="travelPurpose.masterDataID">{{travelPurpose?.mdTitle}}</label>
                                        </ng-container>
                                    </div>
                                    <!-- <div *ngIf="submitted && quotationFieldsForm.get('travelPurpose')?.invalid && quotationFieldsForm.get('travelPurpose')?.errors?.['required']" class="text-red small">
                                    Travel Purpose is required.
                                </div> -->
                                </div>
                                <div class="mb-2">
                                    <label class="field-label">Destination(s) </label>
                                    <div class="">
                                        <mat-form-field class="w-100 example-chip-list">
                                            <mat-chip-grid #chipGrid1 aria-label="Destination selection"
                                                formControlName="destination">
                                                <mat-chip-row *ngFor="let destination of selectedDestinations"
                                                    (removed)="remove(destination)">
                                                    {{destination.ToCountryName}}
                                                    <button matChipRemove
                                                        [attr.aria-label]="'remove ' + destination.ToCountryName">
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip-row>
                                            </mat-chip-grid>

                                            <input #destinationInput1 (focus)="onFocus()" [matChipInputFor]="chipGrid1"
                                                [matAutocomplete]="auto" />
                                            <mat-autocomplete #auto="matAutocomplete"
                                                (optionSelected)="selected($event)">
                                                <mat-option *ngFor="let destination of filteredDestinations | async"
                                                    [value]="destination.TocountryID">
                                                    {{destination.ToCountryName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <!-- <div *ngIf="submitted && selectedDestinations.length==0" class="text-red small">
                                            Destination is required.
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Trip Start Date </label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="tripStartDate" [min]="minTripStartDate"
                                                formControlName="tripStartDate" placeholder="DD/MM/YYYY">
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="tripStartDate"></mat-datepicker-toggle>
                                            <mat-datepicker #tripStartDate></mat-datepicker>
                                        </mat-form-field>
                                        <!-- <div class="text-red small" *ngIf="submitted && quotationFieldsForm.get('tripStartDate')?.invalid && quotationFieldsForm.get('tripStartDate')?.errors?.['required']">
                                            Trip Start Date is required.
                                        </div> -->
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Trip End Date </label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="tripEndDate" [min]="minTripEndDate"
                                                formControlName="tripEndDate" placeholder="DD/MM/YYYY">
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="tripEndDate"></mat-datepicker-toggle>
                                            <mat-datepicker #tripEndDate></mat-datepicker>
                                        </mat-form-field>
                                        <!-- <div class="text-red small" *ngIf="submitted && quotationFieldsForm.get('tripEndDate')?.invalid && quotationFieldsForm.get('tripEndDate')?.errors?.['required']">
                                            Trip End Date is required.
                                        </div> -->
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="field-label">Traveling Days </label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" (input)="numberOnly($event)"
                                            formControlName="travelingDays">
                                    </mat-form-field>
                                    <!-- <div class="text-red small" *ngIf="submitted && quotationFieldsForm.get('travelingDays')?.invalid && quotationFieldsForm.get('travelingDays')?.errors?.['required']">
                                        Traveling Days is required.
                                    </div> -->
                                </div>
                                <div class="mb-2">
                                    <label class="field-label">Number of Travelers </label>
                                    <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="numberOfTravelers" maxlength="1"
                                            (keypress)="numberOnly($event)" (blur)="numberOfTravelers()">
                                    </mat-form-field>
                                    <!-- <div class="text-red small" *ngIf="submitted && quotationFieldsForm.get('numberOfTravelers')?.invalid && quotationFieldsForm.get('numberOfTravelers')?.errors?.['required']">
                                        Number of Travelers is required.
                                    </div> -->
                                </div>
                            </form>
                        </section>


                    </div>

                    <div class="tab-pane fade" id="v-pills-2" role="tabpanel" aria-labelledby="v-pills-2-tab"
                        tabindex="0">
                        <div class="heading2 mb-4">Proposal Form</div>
                        <section>
                            <form [formGroup]="proposalForm">
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Product Name </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="productName">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                        *ngIf="submitted && proposalForm.get('productName')?.invalid && proposalForm.get('productName')?.errors?.['required']">
                                        Product Name is required.
                                    </div> -->
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Premium Amount </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="premiumAmount">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                        *ngIf="submitted && proposalForm.get('premiumAmount')?.invalid && proposalForm.get('premiumAmount')?.errors?.['required']">
                                        Premium Amount is required.
                                    </div> -->
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="field-label">Destination(s) </label>
                                    <div class="">
                                        <mat-form-field class="example-chip-list w-100">
                                            <mat-chip-grid #chipGrid aria-label="Destination selection"
                                                formControlName="destination">
                                                <mat-chip-row *ngFor="let destination of selectedDestinations"
                                                    (removed)="remove(destination)">
                                                    {{destination.ToCountryName}}
                                                    <button matChipRemove
                                                        [attr.aria-label]="'remove ' + destination.ToCountryName">
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip-row>
                                            </mat-chip-grid>

                                            <input #destinationInput (focus)="onFocus()" [matChipInputFor]="chipGrid"
                                                [matAutocomplete]="auto" />
                                            <mat-autocomplete #auto="matAutocomplete"
                                                (optionSelected)="selected($event)">
                                                <mat-option *ngFor="let destination of filteredDestinations | async"
                                                    [value]="destination.TocountryID">
                                                    {{destination.ToCountryName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                          *ngIf="submitted && selectedDestinations.length==0">
                                          Destination is required.
                                      </div> -->
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Trip Start Date </label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="tripStartDate1"
                                                formControlName="tripStartDate" placeholder="DD/MM/YYYY">
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="tripStartDate1"></mat-datepicker-toggle>
                                            <mat-datepicker #tripStartDate1></mat-datepicker>
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                            *ngIf="submitted && proposalForm.get('tripStartDate')?.invalid && proposalForm.get('tripStartDate')?.errors?.['required']">
                                            Trip Start Date is required.
                                        </div> -->
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Trip End Date </label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="tripEndDate1" [min]="minTripEndDate"
                                                formControlName="tripEndDate" placeholder="DD/MM/YYYY">
                                            <mat-datepicker-toggle matIconSuffix
                                                [for]="tripEndDate1"></mat-datepicker-toggle>
                                            <mat-datepicker #tripEndDate1></mat-datepicker>
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                            *ngIf="submitted && proposalForm.get('tripEndDate')?.invalid && proposalForm.get('tripEndDate')?.errors?.['required']">
                                            Trip End Date is required.
                                        </div> -->
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Traveling Days </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" (keypress)="numberOnly($event)"
                                                formControlName="travelingDays">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                            *ngIf="submitted && proposalForm.get('travelingDays')?.invalid && proposalForm.get('travelingDays')?.errors?.['required']">
                                            Traveling Days is required.
                                        </div> -->
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Number of Travelers </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="numberOfTravelers"
                                                (keypress)="numberOnly($event)" (blur)="numberOfTravelers()">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                            *ngIf="submitted && proposalForm.get('numberOfTravelers')?.invalid && proposalForm.get('numberOfTravelers')?.errors?.['required']">
                                            Number of Travelers is required.
                                        </div> -->
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <label class="field-label">KRA Pin Type</label>
                                    <div>
                                      <mat-radio-group formControlName="kraPinType">
                                        <mat-radio-button *ngFor="let kRAPintype of kRAPintypeList" [value]="kRAPintype.masterDataID">
                                          {{ kRAPintype.mdTitle }}
                                        </mat-radio-button>
                                      </mat-radio-group>
                                    </div>
                                  </div>
                  
                                  <div class="row">
                                    <div class="col-md-6 mb-2">
                                      <label class="field-label">KRA Pin Number</label>
                                      <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="kraPinNumber">
                                      </mat-form-field>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                      <label class="field-label">Insured's Occupation</label>
                                      <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="insuredOccupation">
                                      </mat-form-field>
                                    </div>
                                  </div>
                  
                                  <div class="row">
                                    <div class="col-md-6 mb-2">
                                      <label class="field-label">Beneficiary Name</label>
                                      <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput type="text" formControlName="beneficiaryName">
                                      </mat-form-field>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                      <label class="field-label">Beneficiary Mobile Number</label>
                                      <mat-form-field class="w-100 mat-form-field-sm">
                                        <input matInput (keypress)="numberOnly($event)" type="text"
                                          formControlName="beneficiaryTelephoneNo">
                                      </mat-form-field>
                                    </div>
                                  </div>
                                <section formGroupName="address">
                                    <div class="heading2 mt-4 mb-2">Postal Address</div>
                                    <div class="mb-2">
                                        <label class="field-label">House Number </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="houseNumber">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                        *ngIf="submitted && proposalForm.get('address.houseNumber')?.invalid && proposalForm.get('address.houseNumber')?.errors?.['required']">
                                        House Number is required.
                                    </div> -->
                                    </div>
                                    <div class="mb-2">
                                        <label class="field-label">Road Name </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="roadName">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                        *ngIf="submitted && proposalForm.get('address.roadName')?.invalid && proposalForm.get('address.roadName')?.errors?.['required']">
                                        Road Name is required.
                                    </div> -->
                                    </div>
                                    <div class="mb-2">
                                        <label class="field-label">Pincode </label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="pincode"
                                                (keypress)="numberOnly($event)">
                                        </mat-form-field>
                                        <!-- <div class="text-red small"
                                        *ngIf="submitted && proposalForm.get('address.pincode')?.invalid && proposalForm.get('address.pincode')?.errors?.['required']">
                                        Pincode is required.
                                    </div> -->
                                    </div>
                                </section>
                            </form>

                        </section>
                    </div>

                    <div class="tab-pane fade" id="v-pills-3" role="tabpanel" aria-labelledby="v-pills-3-tab"
                        tabindex="0">
                        <section class="mt-4">
                            <form [formGroup]="travelersForm">
                                <section class="mt-4" formArrayName="travelersDetails">
                                    <div class="heading1 mb-4">Traveler Details</div>
                                    <div *ngFor="let travelerDetail of getTravelersDetails.controls; let i = index"
                                        [formGroupName]="i" class="mb-4">
                                        <div class="heading2">
                                            Traveler {{i + 1}}
                                            <section class="example-section d-inline">
                                                <mat-checkbox formControlName="isProposerATraveller">Is the Proposer?
                                                </mat-checkbox>
                                            </section>
                                        </div>
                                        <div class="row">
                                            <!-- <div class="col-md-4 mb-2">
                                                <label class="field-label">Title </label>
                                                <mat-form-field>
                                                    <mat-select formControlName="title">
                                                        <mat-option value="option1">Mr</mat-option>
                                                        <mat-option value="option2">Mrs</mat-option>
                                                        <mat-option value="option3">others</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div> -->
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">First Name </label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput type="text" formControlName="firstName">
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Last Name </label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput type="text" formControlName="lastName">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Name as per the passport </label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput type="text" formControlName="nameAsPerThePassport">
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Email ID</label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput type="text" formControlName="emailId">
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Date of Birth</label>
                                                <mat-form-field class="w-100">
                                                    <input matInput [matDatepicker]="picker" [max]="dateOfBirthMaxDate"
                                                        formControlName="dateOfBirth" placeholder="DD/MM/YYYY"
                                                        (dateChange)="dateOfBirthChange($event,i)">
                                                    <mat-datepicker-toggle matIconSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker="matDatepicker"></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Age</label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput (keypress)="numberOnly($event)" type="text"
                                                        formControlName="age">
                                                </mat-form-field>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <div class="col-4 mb-2">
                                                <label class="field-label">Country Code</label>
                                                <mat-form-field class="w-100">
                                                    <mat-select formControlName="mobileCode">
                                                        <mat-option *ngFor="let code of countryCodes"
                                                            [value]="code.masterDataID">
                                                            <span> {{code.mdTitle}}</span>
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-8 mb-2">
                                                <label class="field-label">Mobile Number</label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput (keypress)="numberOnly($event)" type="text"
                                                        formControlName="mobileNumber">
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Passport Number</label>
                                                <mat-form-field class="w-100 mat-form-field-sm">
                                                    <input matInput type="text" formControlName="passportNumber">
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="field-label">Relationship with the proposer</label>
                                                <mat-form-field class="w-100">
                                                    <mat-select formControlName="relationshipWithTheProposer">
                                                        <mat-option *ngFor="let relationship of relationshipList"
                                                            [value]="relationship.masterDataID">
                                                            {{relationship.mdTitle}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>

                                        </div>

                                        <div class="mb-2"
                                            *ngIf="travelerDetail.get('passportFileAttachmentID')?.value!='00000000-0000-0000-0000-000000000000'">
                                            <div ><a class="link" (click)="DownloadPassportCopy(i)">Download Passport <i
                                                        class="fa-solid fa-download"></i></a> </div>
                                        </div>
                                    </div>
                                </section>
                            </form>
                        </section>
                    </div>
                    <div class="tab-pane fade" id="v-pills-4" role="tabpanel" aria-labelledby="v-pills-4-tab"
                        tabindex="0">
                        <div class="heading2 mb-4">Coverages</div>
                        <p>The following coverages are included in this product:</p>
                        <div>
                            <div class="table-responsive table-block">
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th class="fixed-column-1 fixed-column--index-2">Coverages</th>
                                            <th class="fixed-column-2 fixed-column--index-2">Cover Limits</th>
                                            <th *ngFor="let product of productDetails" class="text-center">
                                                {{ product.ProductName }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let coverage of coveragesList">
                                            <tr
                                                *ngFor="let data of (coverage.additionalData.length ? coverage.additionalData : [{}]); let i = index">
                                                <ng-container *ngIf="i === 0">
                                                    <td [attr.rowspan]="coverage.additionalData.length || 1" class="fixed-column-1">{{
                                                        coverage.CoverageName }}</td>
                                                </ng-container>
                                                <td *ngIf="data.AdditionalCoverageLabel" class="fixed-column-2">{{
                                                    data.AdditionalCoverageLabel }}</td>
                                                <td *ngIf="!data.AdditionalCoverageLabel" class="text-center fixed-column-2">-</td>
                                                <td *ngFor="let product of productDetails" class="text-center">
                                                    <ng-container
                                                        *ngIf="product.coverageQuotesCompare[coverage.CoverageID] && product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]; else noData">
                                                        <div class="text-center text-success">
                                                            <i class="fa-solid fa-check"></i>
                                                        </div>
                                                        <div>
                                                            {{
                                                            product.coverageQuotesCompare[coverage.CoverageID][data.AdditionalCoverageID]
                                                            }}
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #noData>
                                                        <div class="text-center text-red">
                                                            <i class="fa-solid fa-xmark"></i>
                                                        </div>
                                                    </ng-template>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>